import { AccessibilityHelper } from "../GlobalAssets/js/accessibilityHelper";

class IndustryListing {
  constructor(component) {
    this.refs = {
      item: '.js-industry-item',
    };
    
    this.dom = {
      $items: document.querySelectorAll(this.refs.item),
    };

    this.state = {
      accessibilityHelper: new AccessibilityHelper(),
    };

    this.mount();

    this.init();
  }

  mount() {
    const { dom } = this;
    
    dom.$items.forEach(item => {
      item.addEventListener('click', this.toggleItem.bind(this));
      item.addEventListener('mouseenter', this.toggleItem.bind(this));
      item.addEventListener('focus', this.toggleItem.bind(this));
    });
  }

  init() {
    const { dom, state } = this;

    // Initialize accessibility states
    dom.$items.forEach($el => {
      const isActive = $el.classList.contains('is-active');
      state.accessibilityHelper.updateElementAccessibility($el, isActive);
    });
  }

  toggleItem(e) {
    const { dom, state } = this;

    const $item = e.currentTarget;

    dom.$items.forEach($el => {
      $el.classList.remove('is-active');
      state.accessibilityHelper.updateElementAccessibility($el, false);
    });

    $item.classList.add('is-active');

    state.accessibilityHelper.updateElementAccessibility($item, true);
  }
}

const $industryListing = document.querySelector('.js-industry-listing');
if ($industryListing) new IndustryListing($industryListing);
